"use client";

import React from "react";
import { Controller, useFormContext } from "react-hook-form";

import { SelectEventLocationType } from "./select-event-location-type.tsx";

interface PropTypes {
	name: string;
}

export const RHFSelectEventLocationType: React.FC<PropTypes> = (props) => {
	const { name } = props;
	const { control } = useFormContext();

	return (
		<Controller
			name={name}
			control={control}
			render={({ field, fieldState: { error } }) => {
				// eslint-disable-next-line @typescript-eslint/no-unused-vars
				const { ref, ...rest } = field;
				return <SelectEventLocationType {...rest} error={error} />;
			}}
		/>
	);
};
